import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
}
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  onClick,
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy';
  const variantStyles = {
    primary: 'bg-navy text-white hover:bg-navy/90 focus:ring-navy',
    secondary: 'bg-sky-blue text-white hover:bg-sky-blue/90 focus:ring-sky-blue',
    outline: 'bg-transparent border border-navy text-navy hover:bg-navy/10 focus:ring-navy'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  const allStyles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <Link to={href} className={allStyles} data-id="element-105">
        {children}
      </Link>;
  }
  return <button type={type} className={allStyles} onClick={onClick} data-id="element-106">
      {children}
    </button>;
}